import $axios from 'axios'
import { compact, clone } from './utils.js'
const apiurl = path => `/referralrest/${path}`
const api = {
  essential (params) {
    return $axios.post(apiurl('user/referralPartner'), compact(clone(params)))
  },
  getVerifycode () {
    return $axios.get(`/referralrest/user/verifycode?t=${new Date().getTime()}`)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/information.js